<style lang="scss" scoped></style>

<template>
    <div class="slideout-contact-form md:p-60 px-24 py-40">
        <span class="text-green text-tiny font-bold uppercase" v-html="translations.subtitle"></span>
        <h2 class="text-h2 mb-24 font-bold" v-html="translations.title"></h2>
        <p class="mb-40" v-html="translations.intro"></p>
        <el-form button-class="btn btn-green btn-sm btn-rounded font-bold" @submit="submit" :loading="loading" :success="success" :error="server_error" :disclaimer="translations.required_subtitle" :submit-text="translations.send">
            <div class="flex flex-wrap -mx-12">
                <el-input class="md:w-1/2 w-full px-12 mb-24" v-model="formData.first_name" rules="required" :label="translations.first_name"></el-input>
                <el-input class="md:w-1/2 w-full px-12 mb-24" v-model="formData.last_name" rules="required" :label="translations.last_name"></el-input>
                <el-input class="md:w-1/2 w-full px-12 mb-24" v-model="formData.email" rules="required|email" :label="translations.email"></el-input>
                <el-input class="md:w-1/2 w-full px-12 mb-24" v-model="formData.phone" rules="required" :label="translations.phone"></el-input>
            </div>
            <el-input v-model="formData.description" rules="required" :label="translations.message" type="textarea" class="mb-40"></el-input>
            <el-checkbox v-model="formData.legal" name="legal" :rules="{ required: { allowFalse: false } }" :label-text="translations.legal" type="checkbox" class="mb-40"></el-checkbox>
        </el-form>
    </div>
</template>

<script>
import hasForm from "@/mixins/components/has-form";

export default {
    name: "Slideouts.SlideoutContactForm",

    mixins: [hasForm],

    props: {
        translations: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            formData: {
                first_name: "",
                last_name: "",
                email: "",
                phone: "",
                description: "",
                legal: false
            },
            checkboxShouldBe: true
        };
    },

    methods: {
        submit() {
            this.beforeSubmit();

            const payload = {
                name: `${this.formData.first_name} ${this.formData.last_name}`,
                email: this.formData.email,
                phone: this.formData.phone,
                description: this.formData.description
            };

            axios
                .post("/api/contact", payload)
                .then(response => {
                    this.handleSuccess();
                })
                .catch(e => this.handleError(e));
        }
    }
};
</script>
